import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Row, Col, Button } from "reactstrap"

const initPageArr = Array.from({ length: 5 })
const Pagination = (props) => {
    const { totalDataCount, perPage = 15, isLoading = false } = props
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const page = queryParams.get('page') || 1
    const pageNumber = Number(page)
    const history = useHistory()

    const [pageArr, setPageArr] = useState(initPageArr)
    const [pageCount, setPageCount] = useState(0)
    const [standardPage, setStandardPage] = useState(1)

    const makePageGroup = () => {
        const standardPage = Math.floor((pageNumber - 1) / 5) * 5 + 1;
        setStandardPage(standardPage)
        setPageArr(initPageArr.map((v, i) => standardPage + i).filter(v => v <= pageCount))
    }

    const movePage = (page) => {
        if (!isLoading) {
            const scrollY = window.scrollY;
            queryParams.set("page", String(page));
            const url = `${location.pathname}?${queryParams.toString()}`
            history.push(url)
            setTimeout(() => {
                window.scrollTo({ top: scrollY, behavior: 'auto' });
            }, 0);
        }
    }

    const makeContentCount = () => {
        const perPageCount = totalDataCount % perPage === 0 ? totalDataCount / perPage : Math.floor(totalDataCount / perPage) + 1
        setPageCount(totalDataCount === 0 ? 1 : perPageCount)
    };

    useEffect(() => {
        if (pageCount > 0)
            makePageGroup()
    }, [pageCount, pageNumber])

    useEffect(() => {
        makeContentCount()
    }, [totalDataCount])

    return (
        <Row>
            <Col md="12" style={{ textAlign: "center", marginBottom: 20 }}>
                <div className="btn-group mt-4 waver-pagination-btn-group">
                    <Button
                        type="button"
                        size="sm"
                        className={pageNumber !== 1 ? 'waves-effect left-btn active' : 'waves-effect left-btn'}
                        onClick={() => {
                            movePage(standardPage === 1 ? 1 : standardPage - 5)
                        }}
                    >
                        <i className="fa fa-angle-double-left" />
                    </Button>
                    <Button
                        type="button"
                        size="sm"
                        className={pageNumber !== 1 ? 'waves-effect left-btn active' : 'waves-effect left-btn'}
                        onClick={() => {
                            if (pageNumber !== 1) {
                                movePage(pageNumber - 1)
                            }
                        }}
                    >
                        <i className="fa fa-chevron-left" />
                    </Button>
                    {pageArr && pageArr.map((item, index) => {
                        return (
                            <Button
                                key={'pagination_' + index}
                                type="button"
                                size="sm"
                                className={pageNumber === item ? 'waves-effect center-btn active' : 'waves-effect center-btn'}
                                onClick={() => {
                                    movePage(item)
                                }}
                            >
                                {item}
                            </Button>
                        )
                    })}
                    <Button
                        type="button"
                        size="sm"
                        className={pageNumber !== pageCount ? 'waves-effect right-btn active' : 'waves-effect right-btn'}
                        onClick={() => {
                            if (pageNumber !== pageCount) {
                                movePage(pageNumber + 1)
                            }
                        }}
                    >
                        <i className="fa fa-chevron-right" />
                    </Button>
                    <Button
                        type="button"
                        size="sm"
                        className={pageNumber !== pageCount ? 'waves-effect right-btn active' : 'waves-effect right-btn'}
                        onClick={() => {
                            movePage(standardPage + 5 <= pageCount ? standardPage + 5 : pageCount)
                        }}
                    >
                        <i className="fa fa-angle-double-right" />
                    </Button>
                </div>
            </Col>
        </Row>
    )

}

export default Pagination;
